// extracted by mini-css-extract-plugin
export default {"value-container":"kLqsRB","lock-icon":"XQMhzK","left":"PyUxWm","right":"e8SCLs"};